import Image from 'next/image';
import { useRouter } from 'next/router';
import ReactMarkdown from 'react-markdown';
import { IMedia } from '../../../models/strapi.models';
import { getImageSrcWithFallback } from '../../../shared/useUtils';
import { CallToActionWithImageStyle } from '../../../styles/components/common/blocks';
import { Button } from '../ui';

export interface ICallToActionWithImageProps {
  title: string;
  content: string;
  image: IMedia;
  buttons: {
    label: string;
    path?: string;
    action?: () => void;
  }[];
}

const CallToActionWithImage = (props: ICallToActionWithImageProps) => {
  const router = useRouter();

  return (
    <div className={CallToActionWithImageStyle['call-to-action-with-image']}>
      <div
        className={
          CallToActionWithImageStyle['call-to-action-with-image-content']
        }>
        <ReactMarkdown>{props.title}</ReactMarkdown>
        <ReactMarkdown>{props.content}</ReactMarkdown>
        {props.buttons && props.buttons.length > 0 && (
          <div
            className={
              CallToActionWithImageStyle['call-to-action-with-image-buttons']
            }>
            {props.buttons.map((button, index) => (
              <Button
                key={index}
                color={index === 0 ? 'cta' : 'cta-outline'}
                onClick={() => {
                  if (button.path) {
                    router.push(`${button.path}`);
                  } else if (button.action) {
                    button.action();
                  }
                }}>
                {button.label}
              </Button>
            ))}
          </div>
        )}
      </div>
      <div
        className={
          CallToActionWithImageStyle['call-to-action-with-image-image-wrapper']
        }>
        <Image
          quality={90}
          src={getImageSrcWithFallback(props.image, 'large') || ''}
          alt={props.image?.alternativeText || 'Call to Action Image'}
          fill
        />
      </div>
    </div>
  );
};

export default CallToActionWithImage;
